module.exports = __webpack_public_path__ + "img/Tweak_Logo_ForWebApp_AllCaps_SVG.359a2f2c.svg";